<template>
  <div id="pto-entries" v-if="isSignedIn">
    <a-table
            :columns="employeeColumns"
            :data-source="clscPTOEmployees"
            class="components-table-demo-nested"
            :pagination="false"
            :rowKey="record => record.workday_emp_id"
            :loading="isLoadingEmployees"
    >
      <div class="center-col" slot="workday_emp_id" slot-scope="value">{{value}}</div>
      <div class="center-col" slot="employee_name" slot-scope="value">{{value}}</div>
      <div class="center-col" slot="succeeded_hours" slot-scope="value">{{getEntryHours(value)}}</div>
      <div class="center-col" slot="failed_hours" slot-scope="value">
        <template v-if="value > 0">
          <a-tag :key="value" color="red">
            {{getEntryHours(value)}}
          </a-tag>
        </template>
        <template v-else>
          {{getEntryHours(value)}}
        </template>
      </div>
      <div class="center-col" slot="excluded_hours" slot-scope="value">{{getEntryHours(value)}}</div>

      <div class="center-col" slot="expandedRowRender" slot-scope="empRecord">
        <a-table
                :columns="ptoColumns"
                :data-source="ptoByEmployee(empRecord.workday_emp_id)"
                class="components-table-demo-nested"
                :pagination="false"
                :rowKey="record => record.id"
                :rowClassName="() => 'clickable'"
                :customRow="customRowProps"
        >
          <div class="center-col" slot="view_icon" slot-scope="value, record, index">
            <a-icon v-if="iconVisibleIndex === index" type="search" :style="{fontSize: '18px', color:'gray'}" />
          </div>
          <div class="center-col" slot="date_performed" slot-scope="value">{{value? formatDateMMDDYYYY(value) : '' }}
          </div>
          <div class="center-col" slot="reference_id" slot-scope="value">{{value}}</div>
          <div class="center-col" slot="hours" slot-scope="value">{{getEntryHours(value)}}</div>
          <div class="center-col" slot="status" slot-scope="status, record">
            {{status}}
            <a-popover v-if="record.error_message && record.error_message != ''" :title="status">
              <template slot="content">
                <p>{{record.error_message}}</p>
              </template>
              <a-icon type="question-circle"/>
            </a-popover>
          </div>
        </a-table>
      </div>
    </a-table>

    <a-modal
            title="Mavenlink Time Entries"
            :visible="modalVisible"
            :confirm-loading="modalLoading"
            :footer="null"
            @cancel="closeModal"
            width="50vw"
    >
      <raw-time-entries :key="rawTimeEntryKey"
                        :batch-id="rawTimeEntryParams.batchId"
                        :workday-emp-id="rawTimeEntryParams.workdayEmpId"
                        :date-performed="rawTimeEntryParams.datePerformed"
                        :entry-type="rawTimeEntryParams.entryType"
                        :pto-subtype="rawTimeEntryParams.ptoSubtype" />
    </a-modal>

  </div>
</template>

<script>
  import moment from "moment";
  import { mapState, mapGetters, mapMutations } from "vuex";
  import axios from "axios";
  import RawTimeEntries from "./RawTimeEntries";

  const employeeColumns = [
    {
      title: "Employee ID",
      dataIndex: "workday_emp_id",
      key: "workday_emp_id",
      scopedSlots: { customRender: "workday_emp_id" }
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
      scopedSlots: { customRender: "employee_name" }
    },
    {
      title: "Effective PTO Hours",
      dataIndex: "employee_succeeded_minutes",
      key: "succeeded_hours",
      scopedSlots: { customRender: "succeeded_hours" }
    },
    {
      title: "Hours Failed To Import",
      dataIndex: "employee_failed_minutes",
      key: "failed_hours",
      scopedSlots: { customRender: "failed_hours" }
    },
    {
      title: "Hours Excluded In Import",
      dataIndex: "employee_excluded_minutes",
      key: "excluded_hours",
      scopedSlots: { customRender: "excluded_hours" }
    },
  ];

  const ptoColumns = [
    {
      key: "view_icon",
      width: 200,
      scopedSlots: { customRender: "view_icon" }
    },
    {
      title: "Workday Reference ID",
      dataIndex: "reference_id",
      key: "reference_id",
      width: 500,
      scopedSlots: { customRender: "reference_id" }
    },
    {
      title: "Date Performed",
      dataIndex: "date_performed",
      key: "date_performed",
      scopedSlots: { customRender: "date_performed" }
    },
    {
      title: "No. of Hours",
      dataIndex: "total_minutes",
      key: "hours",
      scopedSlots: { customRender: "hours" }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      scopedSlots: { customRender: "status" }
    },
  ];

  export default {
    name: "PtoEntries",
    components: { RawTimeEntries },
    computed: {
      ...mapState(["apiUrl"]),
      ...mapGetters('auth', ["isSignedIn","getUUID"]),
    },
    data() {
      return {
        employeeColumns: employeeColumns,
        ptoColumns: ptoColumns,
        clscPTOEmployees: [],
        clscPTOs: [],
        isLoadingEmployees: false,
        dateFormat: "YYYY-MM-DD",
        iconVisibleIndex: null,
        modalVisible: false,
        modalLoading: false,
        rawTimeEntryKey: null,
        rawTimeEntryParams: {},
      };
    },
    methods: {
      ...mapMutations('auth', ["signInFailed"]),
      fetchCoalescedPTOEmployees() {
        this.isLoadingEmployees = true;
        axios({
          url: `${this.apiUrl}/getBatchEntries`,
          params: {
            action: "FETCH_COALESCED_PTO_EMPLOYEES",
            batchId: this.batchId,
          },
          headers: {
            Authorization: 'Bearer ' + this.getUUID
          }
        })
          .then(rslt => {
            this.clscPTOEmployees = rslt.data;
            this.isLoadingEmployees = false;
          })
          .catch(err => {
            //In the case the endpoint returns a 401, that means
            // our session token has expired. Reroute to /sso-login
            if(err.response.status == 401) {
              this.signInFailed("Session has expired.");
              this.$router.push(`/sso-login`);
            }
            else {
              alert("Unable to load batch employees");
              this.isLoadingEmployees = false;
            }
          });
      },
      fetchCoalescedPTOs() {
        axios({
          url: `${this.apiUrl}/getBatchEntries`,
          params: {
            action: "FETCH_COALESCED_PTO",
            batchId: this.batchId,
          },
          headers: {
            Authorization: 'Bearer ' + this.getUUID
          }
        })
          .then(rslt => {
            this.clscPTOs = rslt.data;
          })
          .catch(err => {
            //In the case the endpoint returns a 401, that means
            // our session token has expired. Reroute to /sso-login
            if(err.response.status == 401) {
              this.signInFailed("Session has expired.");
              this.$router.push(`/sso-login`);
            }
            else {
              alert("Unable to load batch PTOs");
            }
          });
      },
      ptoByEmployee(workdayEmpId) {
        return this.clscPTOs.filter(pto => pto.workday_emp_id === workdayEmpId && pto.batch_id === this.batchId);
      },
      formatDateMMDDYYYY(date) {
        return moment(date).format("MM/DD/YYYY");
      },
      // Round-up to 2 decimal places
      getEntryHours(minutes) {
        return Math.round((minutes / 60) * 100) / 100;
      },
      openModal(record) {
        this.rawTimeEntryParams = {
          batchId: record.batch_id,
          workdayEmpId: record.workday_emp_id,
          datePerformed: record.date_performed,
          entryType: record.entry_type,
          ptoSubtype: record.pto_subtype,
        };
        // force re-render the raw-time-entry component by refreshing the key
        this.rawTimeEntryKey = this.rawTimeEntryParams.workdayEmpId + this.rawTimeEntryParams.datePerformed;
        this.modalVisible = true;
      },
      closeModal() {
        this.modalVisible = false;
      },
      refreshRawEntryKey() {
        return this.rawTimeEntryParams.workdayEmpId + this.rawTimeEntryParams.datePerformed;
      },
      customRowProps(record, index) {
        return {
          props: {},
          on: {
            // click row
            click: (event) => {
              this.openModal(record);
            },
            mouseenter: (event) => {
              this.iconVisibleIndex = index;
            },
            mouseleave: (event) => {
              this.iconVisibleIndex = null;
            },
          },
        }
      },
    },
    mounted() {
      this.fetchCoalescedPTOEmployees();
      this.fetchCoalescedPTOs();
    },
    props: ["batchId"]
  }
</script>

<style lang="scss" scoped>
</style>